module.exports = __webpack_public_path__ + "static/media/shopping-basket.65d1a232.svg";